import {IColumn} from 'models';
import {FileAllTableColumnsEnum} from '../enums';

export const getFilteredFilesColumns = (columns: IColumn[], filterParam: FileAllTableColumnsEnum) =>
  columns.filter((col) => col.id !== filterParam);
